export { default } from './ContentCard';
export type { ContentCardProps } from './ContentCard';
